var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.9,
    height: 39.6,
    viewBox: "0 0 31.9 39.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-20.25 -13.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9790",
    "data-name": "Path 9790",
    d: "M19.2,2A15.2,15.2,0,0,0,4,17.2C4,27.46,17.395,39.05,17.965,39.544a1.9,1.9,0,0,0,2.47,0C21.1,39.05,34.4,27.46,34.4,17.2A15.2,15.2,0,0,0,19.2,2Zm0,33.535C15.153,31.735,7.8,23.546,7.8,17.2a11.4,11.4,0,1,1,22.8,0C30.6,23.546,23.247,31.754,19.2,35.535ZM19.2,9.6a7.6,7.6,0,1,0,7.6,7.6A7.6,7.6,0,0,0,19.2,9.6Zm0,11.4A3.8,3.8,0,1,1,23,17.2,3.8,3.8,0,0,1,19.2,21Z",
    transform: "translate(17 12)",
    fill: "#0804b5",
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bdd3cfdc1aa96907e2807c4eeec67d91.svg";
export { ForwardRef as ReactComponent };